module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-section-2-fbc03ba9987d8e338e8ce2dcc8e45eec.webp";